// extracted by mini-css-extract-plugin
module.exports = {"emptyHint":"EmptyHint_emptyHint__1cm8A","borderTop":"EmptyHint_borderTop__1jBoK","borderBottom":"EmptyHint_borderBottom__1eMQX","icon":"EmptyHint_icon__1J88s"};